module.exports = __webpack_public_path__ + "static/img/9.06557b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/9.png
// module id = C10I
// module chunks = 0